import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ListIcon } from "@phosphor-icons/react";
import { Button } from "@libs/zapi-ui/ds/components/button";
import { getRouteProjects } from "@/zapi-frontend/shared/const/router";
import { useMediaQuery } from "@/zapi-frontend/shared/hooks/useMediaQuery";
import { useSettingsNavStore } from "@/zapi-frontend/stores/settingsNav";
import {
  AppHeaderBrand,
  AppHeaderDivider,
  AppHeaderEnd,
  AppHeaderPage,
  AppHeaderStart
} from "@/zapi-frontend/widgets/Header/ui/blocks/AppHeader";
import { settingsFrom } from "../lib/settingsReturn";

export function SettingsHeader({ end }: { end?: ReactNode }) {
  const { t } = useTranslation(["settings", "projectHome"]);
  const isMobile = useMediaQuery("(max-width: 767px)");
  const openNav = useSettingsNavStore((state) => state.setOpen);
  const navigate = useNavigate();
  const from = settingsFrom(useLocation());

  return (
    <>
      <AppHeaderStart className="gap-1 sm:gap-3">
        {isMobile && (
          <Button
            variant="ghost"
            size="icon"
            aria-label={t("projectHome:header.openNavigation")}
            data-testid="settings-nav-toggle"
            onClick={() => openNav(true)}
            className="-ms-1.5 shrink-0"
          >
            <ListIcon />
          </Button>
        )}
        <AppHeaderBrand
          render={<Link to={getRouteProjects()} data-testid="header-logo-link" />}
          aria-label={t("projectHome:header.brandLabel")}
          className="hidden sm:flex"
        />
        <AppHeaderDivider className="hidden sm:block" />
        <AppHeaderPage
          title={t("settings:title")}
          label={t("projectHome:header.breadcrumb")}
          backLabel={t("settings:redesign.back")}
          onBack={() => navigate(from ?? getRouteProjects())}
        />
      </AppHeaderStart>
      <AppHeaderEnd>{end}</AppHeaderEnd>
    </>
  );
}
